export class EmpleadoEconomica {

    constructor({ tipoFrmEmpresa = null } = {}) {
        this.tipoFrmEmpresa = tipoFrmEmpresa;
        this.model = {
        id: { value: null, header: 'Código' },
        ingreso_mensual_dependencia_empleado: { value: 0, header: 'Ingreso Mensual en Relación de dependencia (Empleado / Colaborador) USD:', required: 'Ingreso mensual es requerido.' },
        otros_ingreso_empleado: { value: 0, header: 'Otros Ingresos (Empleado / Colaborador) USD:', required: 'Otros ingresos es requerido.' },
        fuentes_ingresos_empleado: {
            value: '', header: 'Especifique la fuente de los otros ingresos del Empleado:', maxLength: 'Máximo 200 caracteres',
            minLength: 'Mínimo 4 caracteres', max: 200, min: 4,
            headerPorTipo: {
                FRM_TOYOTA: 'Especifique la fuente de los otros ingresos del Empleado / Colaborador:',
                FRM_DIFARE: 'Especifique la fuente de los otros ingresos del Empleado / Colaborador:',
            }
        },
        otra_actividad_economica: { value: null, header: 'Otras actividades económicas (Empleado / Colaborador):', required: 'Actividad Económica es requerido.' },
        ingreso_mensual_conyugue: { value: 0, header: 'Ingreso Mensual en Relación de dependencia (Cónyuge/Conviviente) USD:', required: 'Ingreso mensual es requerido.' },
        otros_ingreso_conyugue: { value: 0, header: 'Otros Ingresos (Cónyuge/Conviviente) USD:', required: 'Otros ingresos es requerido.' },
        fuentes_ingresos_conyugue: {
            value: '', header: 'Especifique la fuente de los otros ingresos del Cónyuge/Conviviente:', required: 'Fuente es requerido', maxLength: 'Máximo 200 caracteres',
            minLength: 'Mínimo 4 caracteres', max: 200, min: 4
        },
        otra_actividad_economica_conyugue: { value: null, header: 'Otras actividades económicas (Cónyuge/Conviviente):', required: 'Actividad Económica es requerido.' },
        gasto_individual: { value: 0, header: 'Gastos Individuales (en el caso de ser soltero) / Familiares Mensuales USD:', required: 'Gasto individual es requerido.' },
        ACTV_INMUEBLES: { value: 0, header: 'Bienes inmuebles (casa, departamento, etc.) USD:', required: 'Valor es requerido.' },
        ACTV_MUEBLES: { value: 0, header: 'Bienes muebles (vehículo, enceres, etc.) USD:', required: 'Valor es requerido.' },
        ACTV_EFECTIVO: { value: 0, header: 'Dinero (en efectivo, en bancos u otros) USD:', required: 'Valor es requerido.' },
        ACTV_INVERSIONES: { value: 0, header: 'Inversiones USD:', required: 'Valor es requerido.' },
        ACTV_CREDITOS: { value: 0, header: 'Créditos por cobrar USD:', required: 'Valor es requerido.' },
        ACTV_OTROS: { value: 0, header: 'Otros activos USD:', required: 'Valor es requerido.' },
        PASV_BANCARIOS: { value: 0, header: 'Préstamos bancarios (consumo):', required: 'Valor es requerido.' },
        PASV_HIPOTECARIOS: { value: 0, header: 'Préstamos hipotecarios:', required: 'Valor es requerido.' },
        PASV_QUIROGRAFARIO: { value: 0, header: 'Préstamo quirografario:', required: 'Valor es requerido.' },
        PASV_CREDITO: { value: 0, header: 'Tarjeta de crédito:', required: 'Valor es requerido.' },
        PASV_OTRAS_CTAS: { value: 0, header: 'Otras Cuentas / Documentos por pagar USD:', required: 'Valor es requerido.' },
        PASV_OTROS_PASV: { value: 0, header: 'Otros pasivos USD:', required: 'Valor es requerido.' },
        activos: { value: 0, header: 'Total Activos USD:' },
        pasivos: { value: 0, header: 'Pasivos USD:' },
        patrimonio: { value: 0, header: 'Patrimonio (Activos - Pasivos) USD:' },
        }
        Object.keys(this.model).forEach((key) => {
            const campo = this.model[key];
            if (campo.headerPorTipo && tipoFrmEmpresa && campo.headerPorTipo[tipoFrmEmpresa] !== undefined) {
                campo.header = campo.headerPorTipo[tipoFrmEmpresa];
            }
            if (campo.tablePorTipo && tipoFrmEmpresa && campo.tablePorTipo[tipoFrmEmpresa] !== undefined) {
                campo.table = campo.tablePorTipo[tipoFrmEmpresa];
            }
        });
    }

    optionLabel = 'nombre';
}
